module.exports = __webpack_public_path__ + "img/money-simple-from-bracket.938038d6.svg";